import { fetcher } from '../utils'
import { ComponentDefaultMessageVO } from '@repo/types'

export default async (filter: string): Promise<ComponentDefaultMessageVO[]> => {
  return fetcher(`/api/defaultMessage/list?filter=${filter}`, 'GET', undefined)
}
